module.exports = __webpack_public_path__ + "img/product_109.16e4584.webp";